// extracted by mini-css-extract-plugin
module.exports = {"container":"customPhotoDropzone_container__1LvjH"};